import { SvelteComponent, init, safe_not_equal, element, space, attr, add_render_callback, insert, append, select_option, set_input_value, listen, text, noop, detach, destroy_each, run_all, toggle_class, set_data, select_value } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { PLATFORMS } from '../../constants/platforms.js';
import { ENVIRONMENTS } from '../../constants/environments.js';
import { LANGUAGES as e } from '../../external_node_modules/@wg/wows-formatter/utils/languageResolver.js';
import './App.css.js';

/* src/ui/DevPanel/App.svelte generated by Svelte v3.44.2 */

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[19] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[22] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[25] = list[i];
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[28] = list[i];
	return child_ctx;
}

// (39:2) {#if isPanelVisible}
function create_if_block(ctx) {
	let div22;
	let t0;
	let div2;
	let div0;
	let t2;
	let div1;
	let input0;
	let t3;
	let div4;
	let div3;
	let t5;
	let select0;
	let t6;
	let div6;
	let div5;
	let t8;
	let select1;
	let t9;
	let div9;
	let div7;
	let t11;
	let div8;
	let input1;
	let t12;
	let t13;
	let div11;
	let div10;
	let t15;
	let select2;
	let t16;
	let div13;
	let div12;
	let t18;
	let input2;
	let t19;
	let div16;
	let div14;
	let t21;
	let div15;
	let input3;
	let t22;
	let div19;
	let div17;
	let t24;
	let div18;
	let input4;
	let t25;
	let div20;
	let button;
	let t27;
	let t28;
	let div21;
	let mounted;
	let dispose;
	let if_block0 = /*showStaffInfo*/ ctx[5] && create_if_block_3(ctx);
	let each_value_3 = Object.values(PLATFORMS);
	let each_blocks_2 = [];

	for (let i = 0; i < each_value_3.length; i += 1) {
		each_blocks_2[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
	}

	let each_value_2 = Object.values(ENVIRONMENTS);
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks_1[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	let if_block1 = /*isStorefrontOptionsVisible*/ ctx[2] && create_if_block_2(ctx);
	let each_value = Object.values(e);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block2 = /*settings*/ ctx[0].isMaintenanceMode && create_if_block_1();

	return {
		c() {
			div22 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			div2 = element("div");
			div0 = element("div");
			div0.textContent = "Use client mocks";
			t2 = space();
			div1 = element("div");
			input0 = element("input");
			t3 = space();
			div4 = element("div");
			div3 = element("div");
			div3.textContent = "Platform";
			t5 = space();
			select0 = element("select");

			for (let i = 0; i < each_blocks_2.length; i += 1) {
				each_blocks_2[i].c();
			}

			t6 = space();
			div6 = element("div");
			div5 = element("div");
			div5.textContent = "Environment";
			t8 = space();
			select1 = element("select");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t9 = space();
			div9 = element("div");
			div7 = element("div");
			div7.textContent = "Storefront";
			t11 = space();
			div8 = element("div");
			input1 = element("input");
			t12 = space();
			if (if_block1) if_block1.c();
			t13 = space();
			div11 = element("div");
			div10 = element("div");
			div10.textContent = "Language";
			t15 = space();
			select2 = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t16 = space();
			div13 = element("div");
			div12 = element("div");
			div12.textContent = "Country";
			t18 = space();
			input2 = element("input");
			t19 = space();
			div16 = element("div");
			div14 = element("div");
			div14.textContent = "Show anti-fraud popup";
			t21 = space();
			div15 = element("div");
			input3 = element("input");
			t22 = space();
			div19 = element("div");
			div17 = element("div");
			div17.textContent = "Show account completion";
			t24 = space();
			div18 = element("div");
			input4 = element("input");
			t25 = space();
			div20 = element("div");
			button = element("button");
			button.textContent = "Save and reload";
			t27 = space();
			if (if_block2) if_block2.c();
			t28 = space();
			div21 = element("div");
			div21.textContent = "Shown for internal network only";
			attr(div0, "class", "dev-panel-row__name wcl-180y10n");
			attr(input0, "type", "checkbox");
			attr(input0, "class", "wcl-180y10n");
			attr(div1, "class", "dev-panel-row__value wcl-180y10n");
			attr(div2, "class", "dev-panel-row wcl-180y10n");
			attr(div3, "class", "dev-panel-row__name wcl-180y10n");
			attr(select0, "class", "dev-panel-row__value wcl-180y10n");
			if (/*settings*/ ctx[0].platform === void 0) add_render_callback(() => /*select0_change_handler*/ ctx[11].call(select0));
			attr(div4, "class", "dev-panel-row wcl-180y10n");
			attr(div5, "class", "dev-panel-row__name wcl-180y10n");
			attr(select1, "class", "dev-panel-row__value wcl-180y10n");
			if (/*settings*/ ctx[0].environment === void 0) add_render_callback(() => /*select1_change_handler*/ ctx[12].call(select1));
			attr(div6, "class", "dev-panel-row wcl-180y10n");
			attr(div7, "class", "dev-panel-row__name wcl-180y10n");
			attr(input1, "type", "text");
			attr(input1, "class", "wcl-180y10n");
			attr(div8, "class", "dev-panel-row__value wcl-180y10n");
			attr(div9, "class", "dev-panel-row wcl-180y10n");
			attr(div10, "class", "dev-panel-row__name wcl-180y10n");
			attr(select2, "class", "dev-panel-row__value wcl-180y10n");
			if (/*settings*/ ctx[0].language === void 0) add_render_callback(() => /*select2_change_handler*/ ctx[15].call(select2));
			attr(div11, "class", "dev-panel-row wcl-180y10n");
			attr(div12, "class", "dev-panel-row__name wcl-180y10n");
			attr(input2, "class", "dev-panel-row__value wcl-180y10n");
			attr(input2, "type", "text");
			attr(div13, "class", "dev-panel-row wcl-180y10n");
			attr(div14, "class", "dev-panel-row__name wcl-180y10n");
			attr(input3, "type", "checkbox");
			attr(input3, "class", "wcl-180y10n");
			attr(div15, "class", "dev-panel-row__value wcl-180y10n");
			attr(div16, "class", "dev-panel-row wcl-180y10n");
			attr(div17, "class", "dev-panel-row__name wcl-180y10n");
			attr(input4, "type", "checkbox");
			attr(input4, "class", "wcl-180y10n");
			attr(div18, "class", "dev-panel-row__value wcl-180y10n");
			attr(div19, "class", "dev-panel-row wcl-180y10n");
			attr(button, "class", "dev-panel-save__button wcl-180y10n");
			attr(div20, "class", "dev-panel-save wcl-180y10n");
			attr(div21, "class", "dev-panel-internal-network-message wcl-180y10n");
			attr(div22, "class", "dev-panel-container wcl-180y10n");
		},
		m(target, anchor) {
			insert(target, div22, anchor);
			if (if_block0) if_block0.m(div22, null);
			append(div22, t0);
			append(div22, div2);
			append(div2, div0);
			append(div2, t2);
			append(div2, div1);
			append(div1, input0);
			input0.checked = /*settings*/ ctx[0].useClientMocks;
			append(div22, t3);
			append(div22, div4);
			append(div4, div3);
			append(div4, t5);
			append(div4, select0);

			for (let i = 0; i < each_blocks_2.length; i += 1) {
				each_blocks_2[i].m(select0, null);
			}

			select_option(select0, /*settings*/ ctx[0].platform);
			append(div22, t6);
			append(div22, div6);
			append(div6, div5);
			append(div6, t8);
			append(div6, select1);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(select1, null);
			}

			select_option(select1, /*settings*/ ctx[0].environment);
			append(div22, t9);
			append(div22, div9);
			append(div9, div7);
			append(div9, t11);
			append(div9, div8);
			append(div8, input1);
			set_input_value(input1, /*settings*/ ctx[0].storefrontName);
			append(div8, t12);
			if (if_block1) if_block1.m(div8, null);
			append(div22, t13);
			append(div22, div11);
			append(div11, div10);
			append(div11, t15);
			append(div11, select2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select2, null);
			}

			select_option(select2, /*settings*/ ctx[0].language);
			append(div22, t16);
			append(div22, div13);
			append(div13, div12);
			append(div13, t18);
			append(div13, input2);
			set_input_value(input2, /*settings*/ ctx[0].country);
			append(div22, t19);
			append(div22, div16);
			append(div16, div14);
			append(div16, t21);
			append(div16, div15);
			append(div15, input3);
			input3.checked = /*settings*/ ctx[0].purchaseDisabled;
			append(div22, t22);
			append(div22, div19);
			append(div19, div17);
			append(div19, t24);
			append(div19, div18);
			append(div18, input4);
			input4.checked = /*settings*/ ctx[0].accountCompletionEnableForce;
			append(div22, t25);
			append(div22, div20);
			append(div20, button);
			append(div22, t27);
			if (if_block2) if_block2.m(div22, null);
			append(div22, t28);
			append(div22, div21);

			if (!mounted) {
				dispose = [
					listen(input0, "change", /*input0_change_handler*/ ctx[10]),
					listen(select0, "change", /*select0_change_handler*/ ctx[11]),
					listen(select1, "change", /*select1_change_handler*/ ctx[12]),
					listen(input1, "input", /*input1_input_handler*/ ctx[13]),
					listen(input1, "focus", /*toggleStorefrontOptions*/ ctx[7]),
					listen(input1, "blur", /*toggleStorefrontOptions*/ ctx[7]),
					listen(select2, "change", /*select2_change_handler*/ ctx[15]),
					listen(input2, "input", /*input2_input_handler*/ ctx[16]),
					listen(input3, "change", /*input3_change_handler*/ ctx[17]),
					listen(input4, "change", /*input4_change_handler*/ ctx[18]),
					listen(button, "click", /*saveAndReload*/ ctx[9])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (/*showStaffInfo*/ ctx[5]) if_block0.p(ctx, dirty);

			if (dirty & /*settings, Object, PLATFORMS*/ 1) {
				input0.checked = /*settings*/ ctx[0].useClientMocks;
			}

			if (dirty & /*Object, PLATFORMS*/ 0) {
				each_value_3 = Object.values(PLATFORMS);
				let i;

				for (i = 0; i < each_value_3.length; i += 1) {
					const child_ctx = get_each_context_3(ctx, each_value_3, i);

					if (each_blocks_2[i]) {
						each_blocks_2[i].p(child_ctx, dirty);
					} else {
						each_blocks_2[i] = create_each_block_3(child_ctx);
						each_blocks_2[i].c();
						each_blocks_2[i].m(select0, null);
					}
				}

				for (; i < each_blocks_2.length; i += 1) {
					each_blocks_2[i].d(1);
				}

				each_blocks_2.length = each_value_3.length;
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1) {
				select_option(select0, /*settings*/ ctx[0].platform);
			}

			if (dirty & /*Object, ENVIRONMENTS*/ 0) {
				each_value_2 = Object.values(ENVIRONMENTS);
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_2(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(select1, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_2.length;
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1) {
				select_option(select1, /*settings*/ ctx[0].environment);
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1 && input1.value !== /*settings*/ ctx[0].storefrontName) {
				set_input_value(input1, /*settings*/ ctx[0].storefrontName);
			}

			if (/*isStorefrontOptionsVisible*/ ctx[2]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					if_block1.m(div8, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*Object, LANGUAGES*/ 0) {
				each_value = Object.values(e);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select2, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1) {
				select_option(select2, /*settings*/ ctx[0].language);
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1 && input2.value !== /*settings*/ ctx[0].country) {
				set_input_value(input2, /*settings*/ ctx[0].country);
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1) {
				input3.checked = /*settings*/ ctx[0].purchaseDisabled;
			}

			if (dirty & /*settings, Object, PLATFORMS*/ 1) {
				input4.checked = /*settings*/ ctx[0].accountCompletionEnableForce;
			}

			if (/*settings*/ ctx[0].isMaintenanceMode) {
				if (if_block2) ; else {
					if_block2 = create_if_block_1();
					if_block2.c();
					if_block2.m(div22, t28);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div22);
			if (if_block0) if_block0.d();
			destroy_each(each_blocks_2, detaching);
			destroy_each(each_blocks_1, detaching);
			if (if_block1) if_block1.d();
			destroy_each(each_blocks, detaching);
			if (if_block2) if_block2.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

// (41:6) {#if showStaffInfo}
function create_if_block_3(ctx) {
	let div2;
	let div1;
	let div0;
	let t0;
	let t1_value = /*settings*/ ctx[0].realm + "";
	let t1;
	let t2;
	let t3_value = /*settings*/ ctx[0].appVersion + "";
	let t3;
	let t4;
	let t5_value = /*settings*/ ctx[0].staticVersion + "";
	let t5;
	let t6;

	return {
		c() {
			div2 = element("div");
			div1 = element("div");
			div0 = element("div");
			t0 = text("[");
			t1 = text(t1_value);
			t2 = text("] ");
			t3 = text(t3_value);
			t4 = text(" (");
			t5 = text(t5_value);
			t6 = text(")");
			attr(div0, "class", "dev-panel-row__value wcl-180y10n");
			attr(div1, "class", "dev-panel-row wcl-180y10n");
			attr(div2, "class", "dev-panel-staff-info wcl-180y10n");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div1);
			append(div1, div0);
			append(div0, t0);
			append(div0, t1);
			append(div0, t2);
			append(div0, t3);
			append(div0, t4);
			append(div0, t5);
			append(div0, t6);
		},
		p(ctx, dirty) {
			if (dirty & /*settings*/ 1 && t1_value !== (t1_value = /*settings*/ ctx[0].realm + "")) set_data(t1, t1_value);
			if (dirty & /*settings*/ 1 && t3_value !== (t3_value = /*settings*/ ctx[0].appVersion + "")) set_data(t3, t3_value);
			if (dirty & /*settings*/ 1 && t5_value !== (t5_value = /*settings*/ ctx[0].staticVersion + "")) set_data(t5, t5_value);
		},
		d(detaching) {
			if (detaching) detach(div2);
		}
	};
}

// (58:10) {#each Object.values(PLATFORMS) as platform}
function create_each_block_3(ctx) {
	let option;
	let t0_value = /*platform*/ ctx[28] + "";
	let t0;
	let t1;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*platform*/ ctx[28];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (69:10) {#each Object.values(ENVIRONMENTS) as environment}
function create_each_block_2(ctx) {
	let option;
	let t0_value = /*environment*/ ctx[25] + "";
	let t0;
	let t1;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*environment*/ ctx[25];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (86:10) {#if isStorefrontOptionsVisible}
function create_if_block_2(ctx) {
	let ul;
	let each_value_1 = Object.values(/*storefrontOptions*/ ctx[4]);
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(ul, "class", "dev-panel-options wcl-180y10n");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*setStorefront, Object, storefrontOptions*/ 272) {
				each_value_1 = Object.values(/*storefrontOptions*/ ctx[4]);
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (88:14) {#each Object.values(storefrontOptions) as storefrontOption}
function create_each_block_1(ctx) {
	let li;
	let t_value = /*storefrontOption*/ ctx[22] + "";
	let t;
	let mounted;
	let dispose;

	function mousedown_handler() {
		return /*mousedown_handler*/ ctx[14](/*storefrontOption*/ ctx[22]);
	}

	return {
		c() {
			li = element("li");
			t = text(t_value);
			attr(li, "class", "wcl-180y10n");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t);

			if (!mounted) {
				dispose = listen(li, "mousedown", mousedown_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(li);
			mounted = false;
			dispose();
		}
	};
}

// (99:10) {#each Object.values(LANGUAGES) as language}
function create_each_block(ctx) {
	let option;
	let t0_value = /*language*/ ctx[19] + "";
	let t0;
	let t1;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*language*/ ctx[19];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (127:6) {#if settings.isMaintenanceMode}
function create_if_block_1(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = "Maintenance mode";
			attr(div, "class", "dev-panel-maintenance-mode-message wcl-180y10n");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let t0;
	let t1;
	let mounted;
	let dispose;
	let if_block = /*isPanelVisible*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			t0 = text(/*closeButtonText*/ ctx[3]);
			t1 = space();
			if (if_block) if_block.c();
			attr(div0, "class", "dev-panel-trigger wcl-180y10n");
			toggle_class(div0, "opened", /*isPanelVisible*/ ctx[1]);
			attr(div1, "class", "dev-panel wcl-180y10n");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, t0);
			append(div1, t1);
			if (if_block) if_block.m(div1, null);

			if (!mounted) {
				dispose = listen(div0, "click", /*togglePanel*/ ctx[6]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*closeButtonText*/ 8) set_data(t0, /*closeButtonText*/ ctx[3]);

			if (dirty & /*isPanelVisible*/ 2) {
				toggle_class(div0, "opened", /*isPanelVisible*/ ctx[1]);
			}

			if (/*isPanelVisible*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div1, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let closeButtonText;
	let { settings } = $$props;
	let isPanelVisible = false;
	let isStorefrontOptionsVisible = false;
	let storefrontOptions = ['metashop', 'buyprem', 'battlepass'];
	let showStaffInfo = settings.realm && settings.appVersion && settings.staticVersion;

	function togglePanel() {
		$$invalidate(1, isPanelVisible = !isPanelVisible);
	}

	function toggleStorefrontOptions() {
		$$invalidate(2, isStorefrontOptionsVisible = !isStorefrontOptionsVisible);
	}

	function setStorefront(storefront) {
		$$invalidate(0, settings.storefrontName = storefront, settings);
	}

	function saveAndReload() {
		if (settings.dev) {
			settings.dev.saveToUrl();
		}
	}

	function input0_change_handler() {
		settings.useClientMocks = this.checked;
		$$invalidate(0, settings);
	}

	function select0_change_handler() {
		settings.platform = select_value(this);
		$$invalidate(0, settings);
	}

	function select1_change_handler() {
		settings.environment = select_value(this);
		$$invalidate(0, settings);
	}

	function input1_input_handler() {
		settings.storefrontName = this.value;
		$$invalidate(0, settings);
	}

	const mousedown_handler = storefrontOption => setStorefront(storefrontOption);

	function select2_change_handler() {
		settings.language = select_value(this);
		$$invalidate(0, settings);
	}

	function input2_input_handler() {
		settings.country = this.value;
		$$invalidate(0, settings);
	}

	function input3_change_handler() {
		settings.purchaseDisabled = this.checked;
		$$invalidate(0, settings);
	}

	function input4_change_handler() {
		settings.accountCompletionEnableForce = this.checked;
		$$invalidate(0, settings);
	}

	$$self.$$set = $$props => {
		if ('settings' in $$props) $$invalidate(0, settings = $$props.settings);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*isPanelVisible*/ 2) {
			$$invalidate(3, closeButtonText = isPanelVisible ? '✕' : '$');
		}
	};

	return [
		settings,
		isPanelVisible,
		isStorefrontOptionsVisible,
		closeButtonText,
		storefrontOptions,
		showStaffInfo,
		togglePanel,
		toggleStorefrontOptions,
		setStorefront,
		saveAndReload,
		input0_change_handler,
		select0_change_handler,
		select1_change_handler,
		input1_input_handler,
		mousedown_handler,
		select2_change_handler,
		input2_input_handler,
		input3_change_handler,
		input4_change_handler
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { settings: 0 });
	}
}

export { App as default };
//# sourceMappingURL=App.svelte.js.map
